import React, { useEffect, useState } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../services/api';
import { Switch } from './ui/switch';

/**
 * Toggle do empreendedor para receber alertas de solicitações.
 *
 * Lê o estado atual em /v2/businesses/{id} e PUT em /v2/empreendedor/preferencias-notificacao.
 */
export default function PreferenciasNotificacaoToggle({ negocioId, categoria, initialValue = true }) {
  const [enabled, setEnabled] = useState(initialValue);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(initialValue !== undefined);

  // pega valor atualizado do backend (caso o caller só passe o id)
  useEffect(() => {
    if (loaded) return;
    api.get(`/v2/businesses/${negocioId}`)
      .then((r) => {
        const v = r.data?.preferencias_notificacao?.receber_solicitacoes;
        setEnabled(v !== false);
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [negocioId, loaded]);

  async function toggle(v) {
    setSaving(true);
    const prev = enabled;
    setEnabled(v);
    try {
      await api.put('/v2/empreendedor/preferencias-notificacao', { receber_solicitacoes: v }, {
        params: negocioId ? { negocio_id: negocioId } : {},
      });
      toast.success(v ? 'Alertas ativados.' : 'Alertas desativados.');
    } catch (e) {
      setEnabled(prev);
      toast.error(e?.response?.data?.detail || 'Erro ao salvar preferência');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      className="bg-white rounded-xl border border-gray-100 p-4"
      data-testid={`prefs-notif-${negocioId}`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-full ${enabled ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-500'}`}>
          {enabled ? <Bell className="w-4 h-4" /> : <BellOff className="w-4 h-4" />}
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between gap-3">
            <div>
              <h3 className="font-semibold text-sm">Receber alertas de solicitações</h3>
              <p className="text-xs text-gray-500 mt-0.5">
                Receba notificações quando alguém na cidade precisar de <strong>{categoria || 'sua categoria'}</strong>.
                Limite: até 3 alertas por dia.
              </p>
            </div>
            <Switch
              checked={enabled}
              onCheckedChange={toggle}
              disabled={saving}
              data-testid={`prefs-notif-${negocioId}-switch`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
